import type { I_SceneOrientation } from '@containers/Home/types/I_Scene';

export const IDENTITY_PREALIGN = '0|0|0';

const formatAngle = (deg: number): number => {
  const value = Object.is(deg, -0) ? 0 : deg;
  return Math.round(value * 10000) / 10000;
};

export const formatKrpanoPrealign = (
  orientation?: I_SceneOrientation | null,
): string => {
  const x = formatAngle(-(Number(orientation?.pitchDeg) || 0));
  const y = formatAngle(-(Number(orientation?.yawCenterDeg) || 0));
  const z = formatAngle(-(Number(orientation?.rollDeg) || 0));
  if (x === 0 && y === 0 && z === 0) return IDENTITY_PREALIGN;
  return `${x}|${y}|${z}`;
};

export const getKrpanoImageRotationVars = (
  orientation?: I_SceneOrientation | null,
): Record<string, string> => ({
  'image.prealign': formatKrpanoPrealign(orientation),
});

export const withImagePrealign = (
  xml?: string | null,
  prealign?: string | null,
): string => {
  if (!xml) return '';
  if (!prealign || prealign === IDENTITY_PREALIGN) return xml;
  return xml.replace(/<image(\s[^>]*)?>/gi, (_match, attrs = '') => {
    if (/\sprealign\s*=/i.test(attrs)) {
      return `<image${attrs.replace(
        /\sprealign\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/i,
        ` prealign="${prealign}"`,
      )}>`;
    }
    return `<image prealign="${prealign}"${attrs}>`;
  });
};

export const sphereImageXml = (
  url: string,
  prealign: string,
  viewXml = '',
): string => {
  const attr =
    prealign && prealign !== IDENTITY_PREALIGN ? ` prealign="${prealign}"` : '';
  return `<preview url="${url}" /><image${attr}><sphere url="${url}" /></image>${viewXml}`;
};
